// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"79748579","234":"41fb62e3","334":"3b4027af","401":"4e2503f2","416":"0fe2ba9c","646":"b093ee32"}[chunkId] + ".chunk.js";
};